<template>
  <div class="main-page page-service-law">
    <Menus title="政策法规"
           :home="true" />
    <div class="container-flex">
      <div class="law-list-panel">
        <div class="item"
             @click="toDetail( item)"
             v-for="(item, index) in showList"
             :key="'key-law-sort-' + index"
             v-if="!item.parentId">
          <div class="title">
            <span>{{ item.name }}</span>
          </div>
          <div class="detail">实施：{{ $moment(item.enforcementDate).format('YYYY-MM-DD HH:mm') }} 丨
            时效性：{{ item.forceStatus }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Menus from '@/components/Menu'
import { getLawlist } from '@/datas/js/law'
import { RURALLAW } from '@/datas/constants/statistics.js'

export default {
  data () {
    return {
      list: [],
      list1: []
    }
  },
  computed: {
    showList () {
      return [...this.list, ...this.list1]
    }
  },
  components: { Menus },

  async created () {
    this.$root.getStatistics(RURALLAW)

    if (!this.$app.appId) {
      await this.$store.dispatch('app/getAppInfoBySite')
    }
    await Promise.all([
      this.fetchData({ areaId: 'EF33ACF4A6D4493691FC1BDA36F98CBD', professionalId: 'D47BF912080146F885D6AD8F210D3B69' }),// 乡村振兴
      this.fetchData({ areaId: '750DD8CD687341249A83E3412D117BCC', professionalId: 'D47BF912080146F885D6AD8F210D3B69' }), // 乡村振兴
      this.fetchData({ areaId: 'EF33ACF4A6D4493691FC1BDA36F98CBD', professionalId: '158B6122A2414607B8F315B542ADA2A4' }),//农林牧渔
      this.fetchData({ areaId: '750DD8CD687341249A83E3412D117BCC', professionalId: '158B6122A2414607B8F315B542ADA2A4' }), // 农林牧渔
      this.fetchData({ areaId: 'EF33ACF4A6D4493691FC1BDA36F98CBD', professionalId: 'EEEA41814F68448C83076B608C57CCB8' }),//农林牧渔
      this.fetchData({ areaId: '750DD8CD687341249A83E3412D117BCC', professionalId: 'EEEA41814F68448C83076B608C57CCB8' }), // 农林牧渔
      this.fetchData({ areaId: 'EF33ACF4A6D4493691FC1BDA36F98CBD', industryIds: '7F3D15F6F7C54967B8A02125E7E24EA1' }),//农林牧渔
      this.fetchData({ areaId: '750DD8CD687341249A83E3412D117BCC', industryIds: '7F3D15F6F7C54967B8A02125E7E24EA1' }) // 农林牧渔
    ])
  },
  methods: {
    async fetchData ({ areaId = null, professionalId = null, industryIds = null }) {
      const params = {
        professionalId,
        pageNo: 1,
        pageSize: 1000,
        appId: this.$app.appId,
        industryIds,
        forceStatus: 1,
        areaId
      }

      const { data, response } = await getLawlist(params)
      if (response.success) {
        const arr = data && data.result || []
        this.list = [...this.list, ...arr]
      }
    },
    toDetail (item) {
      this.$router.push(`/LawDetail/${item.id}?hide_nav=1&title=详情`)
    }
  }
}
</script>
<style lang="stylus" scoped>
.page-service-law
  .container-flex
    padding 0.3rem 2.6rem 0.5rem 2.6rem
    .law-list-panel
      .item
        padding 0.45rem 0.35rem
        margin-bottom 0.3rem
        background-color #fff
        border-radius 0.08rem
        .title
          font-size 0.3rem
          line-height 0.45rem
          color #666
          margin-bottom 0.2rem
        .detail
          font-size 0.26rem
          color #999
</style>